import { MENU } from '@/constants/menu';
import { PAGES } from '@/constants/pages';
import { SEO_TYPES } from '@/constants/seo';

export const formatBottomLink = (section) => ({
  typeLink: section.bottomTypeLink,
  linkIdentifier: section.bottomIdentifierLink,
  groupIdentifier: section.bottomGroupIdentifier,
  isNofollow: section.bottomIsNofollow,
  picto: section.bottomPicto,
  urlKeyword: section.bottomUrlKeyword,
  name: section.bottomName,
  showEc: section.bottomShowEc,
  className: section.bottomClassName
});

export const normalizeUrl = (url) => {
  const prefix = url?.charAt(0) === '/' || url?.startsWith('http');
  return prefix ? url : `/${url}`;
};

export const buildMenuLink = ({ urlKeyword, typeLink = '', identifierLink, linkIdentifier, anchor }) => {
  if (!urlKeyword) {
    return '#';
  }

  // FIXME: links of type `LANDING_PAGE` does not have any identifier; update them in the BO & the DB
  const linkId = identifierLink || linkIdentifier;

  let slug = normalizeUrl(urlKeyword);

  let additionalParams = {};
  if (slug.includes('?')) {
    const slugIndex = slug.indexOf('?');
    const filter = slug.slice(slugIndex);
    slug = slug.substring(0, slugIndex);
    const searchParams = new URLSearchParams(filter);
    additionalParams = Object.fromEntries(searchParams);
  }

  if (typeLink === MENU.LANDING_PAGE) {
    return {
      pathname: '/[...slug]',
      query: {
        slug: [slug],
        ...additionalParams,
        anchor: anchor
      },
    };
  } else if (linkId) {
    return {
      pathname: [SEO_TYPES.CATEG_SPIRIT, SEO_TYPES.PRODUCT_SPIRIT].includes(typeLink) ? `${PAGES.SPIRIT}/[...spiritSlug]` : '/[...slug]',
      query: {
        slug: [slug],
        type: typeLink,
        id: linkId,
        ...additionalParams,
        anchor: anchor
      }
    };
  }

  return normalizeUrl(urlKeyword);
};

export const stripHtml = (html) => {
  const tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  const content = tmp.textContent || tmp.innerText || '';
  return content.replace(/[\r\n]+/gm, ' ').trim();
};
